import { render } from "./ScheduleIndex.vue?vue&type=template&id=450b7678"
import script from "./ScheduleIndex.vue?vue&type=script&lang=js"
export * from "./ScheduleIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__